import { ArrowRight, Briefcase, User } from 'lucide-react';
import { tenantDetails } from '../../../helpers/utils/types';

interface AccountTypeCardProps {
  accountType: string;
  onChangeAccountType: () => void;
  tenant: tenantDetails;
}

const AccountTypeCard: React.FC<AccountTypeCardProps> = ({
  accountType,
  onChangeAccountType,
  tenant,
}) => {
  const isPersonal = accountType === 'personal';

  const ctaLabel =
    tenant?.tenant?.accountType === 'personal' && tenant?.tenant?.tenantCompanyId
      ? 'Complete company setup'
      : isPersonal
        ? 'Add business account'
        : 'Add personal account';

  const subtitle = isPersonal
    ? 'Pay business vendors & expenses easily'
    : 'Use for personal rent & payments';

  const title = isPersonal ? 'Unlock your business account' : 'Unlock your personal account';

  const Icon = isPersonal ? Briefcase : User;

  return (
    <div className='flex flex-col gap-3 rounded-[13px] border border-[#e5e7eb] bg-white px-[18px] py-[14px] transition hover:border-[#d1d5db] hover:shadow-[0_4px_16px_rgba(0,0,0,0.06)] sm:flex-row sm:items-center sm:gap-[13px]'>
      <div className='flex items-start gap-[13px] sm:min-w-0 sm:flex-1'>
        <div
          className='flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[9px] border border-primary/20 bg-[#eef2ff] text-primary'
          aria-hidden
        >
          <Icon size={14} strokeWidth={2} />
        </div>
        <div className='min-w-0 flex-1'>
          <div className='font-display text-[15px] font-extrabold leading-tight tracking-[-0.02em] text-main'>
            {title}
          </div>
          <div className='mt-0.5 font-sans text-[11px] leading-snug text-medium'>{subtitle}</div>
        </div>
      </div>
      <button
        type='button'
        className='flex w-full shrink-0 items-center justify-center gap-1.5 rounded-[10px] bg-primary px-4 py-2 font-sans text-[11px] font-bold text-white shadow-[0_8px_22px_-8px_rgba(0,85,255,0.45)] transition hover:bg-[#0044cc] sm:w-auto sm:justify-center'
        onClick={onChangeAccountType}
      >
        {ctaLabel}
        <ArrowRight size={12} className='shrink-0' aria-hidden />
      </button>
    </div>
  );
};

export default AccountTypeCard;
